export default __webpack_public_path__ + "static/media/poweroftheserpentring.e79c1a5a.png";